var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProfileOptionSelector',{attrs:{"model":'marry_plan',"nextRoute":() => 'IntroduceMyselfPage'}})
}
var staticRenderFns = []

export { render, staticRenderFns }